import {
    COMEDY_EVENTBRITE_SUB_CATEGORY,
    HOBBIES_EVENTBRITE_CATEGORY,
    LGBT_EVENTBRITE_SUB_CATEGORY,
    MUSIC_EVENTBRITE_CATEGORY,
    PARTY_EVENTBRITE_FORMAT,
} from '@eventbrite/categories';
import { gettext } from '@eventbrite/i18n';
import { OrganicEventSearchFiltersApiPayload } from '../../../api/searchOrganicEvents';
import { DATING_TAGS } from '../components/CategoryFilterBar/constants';

export const DATING = 'dating';

export const DatingTabsSearchQuery: {
    [key: string]: OrganicEventSearchFiltersApiPayload;
} = {
    all: {
        q: DATING,
        tags: [...DATING_TAGS],
    },
    ['speed-dating']: {
        tags: [...DATING_TAGS],
        q: 'speed-dating',
    },
    today: {
        q: DATING,
        tags: [...DATING_TAGS],
        dates: ['current_future', 'today'],
    },
    ['this-weekend']: {
        q: DATING,
        tags: [...DATING_TAGS],
        dates: ['current_future', 'this_weekend'],
    },
    lgbtqia: {
        q: DATING,
        tags: ['EventbriteSubCategory/13004'],
    },
    music: {
        q: DATING,
        tags: [MUSIC_EVENTBRITE_CATEGORY],
    },
    parties: {
        q: DATING,
        tags: [PARTY_EVENTBRITE_FORMAT],
    },
    comedy: {
        q: DATING,
        tags: ['EventbriteSubCategory/5010'],
    },
    ['hobbies&crafts']: {
        q: DATING,
        tags: ['EventbriteCategory/119'],
    },
};
export const categoryMap: Array<any> = [
    {
        category: gettext('All'),
        searchParam: 'all',
        keyword: DATING,
        tagSelector: [...DATING_TAGS],
    },
    {
        category: gettext('Speed dating'),
        searchParam: 'speed-dating',
        keyword: 'speed-dating',
        tagSelector: [...DATING_TAGS],
    },
    {
        category: gettext('Today'),
        searchParam: 'today',
        tagSelector: [...DATING_TAGS],
        keyword: DATING,
        dates: ['current_future', 'today'],
    },
    {
        category: gettext('This weekend'),
        searchParam: 'this-weekend',
        tagSelector: [...DATING_TAGS],
        keyword: DATING,
        dates: ['current_future', 'this_weekend'],
    },
    {
        category: gettext('LGBTQIA+'),
        searchParam: 'lgbtqia',
        keyword: DATING,
        tagSelector: [LGBT_EVENTBRITE_SUB_CATEGORY],
    },
    {
        category: gettext('Parties'),
        searchParam: 'parties',
        keyword: DATING,
        tagSelector: [PARTY_EVENTBRITE_FORMAT],
    },
    {
        category: gettext('Music'),
        searchParam: 'music',
        keyword: DATING,
        tagSelector: [MUSIC_EVENTBRITE_CATEGORY],
    },
    {
        category: gettext('Comedy'),
        searchParam: 'comedy',
        keyword: DATING,
        tagSelector: [COMEDY_EVENTBRITE_SUB_CATEGORY],
    },
    {
        category: gettext('Hobbies and crafts'),
        searchParam: 'hobbies&crafts',
        keyword: DATING,
        tagSelector: [HOBBIES_EVENTBRITE_CATEGORY],
    },
];
